module.exports = __webpack_public_path__ + "img/pagar.3ed465e8.png";